export default {
  roles: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  role:[],
  selected_role : {},
  role_status:[]
}
